<template>
  <div class="body">
    <div class="common-page dark-theme">
      <div class="error-page">
        <slot name="icon">
          <img
            :src="require('@/assets/images/common/icon-error-comp-error.svg')"
            alt="에러 아이콘"
          />
        </slot>
        <p class="error-txt01" v-html="title"></p>
        <p class="error-txt02" v-html="text"></p>
        <div class="btn-purple">
          <a href="javascript:void(0)" @click.prevent="onClick">
            {{ button }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, defineProps } from 'vue'
  import { useRouterComposable } from '@/common/use/useRouterComposable'
  import { getTextBreaks } from '@/common/utils/string-manipulation/get-text-breaks'

  const { pushRouter } = useRouterComposable()

  const DEFAULT_TITLE_404 = '서비스 이용에 불편을 드려 죄송합니다.'
  const DEFAULT_TEXT_404 = `찾으시는 페이지가 없거나 오류가 발생하였습니다.\n입력하신 주소가 정확한지 다시한번 확인해 주세요.\n\n관련 문의사항은 고객센터 1599-3709로 문의하시면 친절하게 안내해드리겠습니다.`
  const DEFAULT_BUTTON_TEXT_404 = `홈으로 가기`

  const props = defineProps({
    errorTitle: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    onClickFn: {
      type: Function,
    },
  })

  const title = computed(() =>
    getTextBreaks(props.errorTitle || DEFAULT_TITLE_404),
  )
  const text = computed(() =>
    getTextBreaks(props.errorText || DEFAULT_TEXT_404),
  )
  const button = computed(() =>
    getTextBreaks(props.buttonText || DEFAULT_BUTTON_TEXT_404),
  )

  const onClick = () => {
    if (props.onClickFn) {
      props.onClickFn()
      return
    }
    pushRouter({ path: '/' })
  }
</script>
<style lang="scss" scoped>
  .common-page {
    .wrap {
      width: initial;
      margin: 0 100px;
    }
    .error-page {
      margin: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      > img {
        width: 90px;
        height: 90px;
      }
      .error-txt01 {
        margin: 40px 0 0;
        line-height: 1.472;
        font-weight: 400;
      }
      .error-txt02 {
        margin: 20px 0 60px;
      }
      .btn-purple {
        a {
          min-width: 236px;
          height: 60px;
          line-height: 60px;
          padding: 0 40px;
          font-size: 18px;
        }
      }
    }
  }
</style>
